export class LlamadoPaciente {
    paciente: string;
    nombreMedico: string;
    box: number;
  }
